// import cloneDeep from 'lodash.clonedeep';
import React from 'react';

import { Node, Port } from 'reaflow';
import styled from 'styled-components';

import ObjectiveNode from '../components/ObjectiveNode';
import RootNode from '../components/RootNode';

const StyledForeignObject = styled.foreignObject`
  position: relative;
  margin-top: 32px;
`;

const BaseNode = ({
  nodeProps,
  isExpanded,
  enableObjectiveCreation,
  forceUpdateValue,
  recalculateNodesEdges,
  onGoalsExpandToggle,
  onGoalCreationClick,
  onGoalObjectiveCreationClick,
  onDelete,
  onUpdate,
  enableKeyResultCreation,
}) => (
  <Node
    {...nodeProps}
    style={{
      display: 'none',
    }}
    port={<Port style={{ fill: '#999999', stroke: '#999999' }} rx={10} ry={10} />}
  >
    {(event) => (
      <StyledForeignObject
        id={`node-foreignObject-${nodeProps.properties.id}`}
        className="node-container"
        width={nodeProps.properties.width}
        height={nodeProps.properties.height}
      >
        {event.node.id === 'root' ? (
          <RootNode
            key={event.node.id}
            onExpandClick={() => {
              const newNodeIdPathArray = [...event.node.data.nodeIdPathArray];
              if (isExpanded) {
                newNodeIdPathArray.pop();
              }
              recalculateNodesEdges({
                newNodeIdPathArray,
              });
            }}
            isExpanded={isExpanded}
            // null because root doesn't not have parent objective
            onObjectiveCreationClick={() =>
              onGoalObjectiveCreationClick({
                objective: event.node.data.objective,
                nodeIdPathArray: event.node.data.nodeIdPathArray,
              })
            }
            enableObjectiveCreation={enableObjectiveCreation}
          />
        ) : (
          <ObjectiveNode
            key={event.node.id}
            onExpandClick={() => {
              const newNodeIdPathArray = [...event.node.data.nodeIdPathArray];
              if (isExpanded) {
                newNodeIdPathArray.pop();
              }
              recalculateNodesEdges({
                newNodeIdPathArray,
              });
            }}
            isExpanded={isExpanded}
            onGoalsExpandToggle={() => onGoalsExpandToggle(event.node.id)}
            {...event.node.data}
            onGoalObjectiveCreationClick={() =>
              onGoalObjectiveCreationClick({
                objective: event.node.data.objective,
                nodeIdPathArray: event.node.data.nodeIdPathArray,
              })
            }
            onGoalCreationClick={() =>
              onGoalCreationClick({
                objective: event.node.data.objective,
                nodeIdPathArray: event.node.data.nodeIdPathArray,
              })
            }
            forceUpdateValue={forceUpdateValue}
            enableObjectiveCreation={enableObjectiveCreation}
            enableKeyResultCreation={enableKeyResultCreation}
            onDelete={onDelete}
            onUpdate={onUpdate}
          />
        )}
      </StyledForeignObject>
    )}
  </Node>
);

export default BaseNode;
